<template>
  <v-card elevation="3" class="my-5 card-fixed-height">
    <v-card-title class="card-header py-3 px-4">
      <v-icon color="catGreen" class="mr-2 flex-shrink-0">
        {{ icon || "mdi-food-apple" }}
      </v-icon>
      <span class="card-title-text">{{ infoTitle }}</span>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text class="pa-4 card-content">
      <div v-if="!latest" class="text-center py-6">
        <v-icon size="48" color="grey lighten-1">mdi-food-off</v-icon>
        <p class="text-caption grey--text mt-2 mb-0">
          Nenhum recordatório alimentar registrado.
        </p>
      </div>

      <div v-else class="recall-body">
        <p class="recall-content">{{ latest.content }}</p>
        <p v-if="latest.recorded_at" class="recall-date">
          Registrado em {{ formatDate(latest.recorded_at) }}
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { getDietaryRecallByPatient } from "@/services/dietaryRecallService";

import dashboardStore from "@/features/patients/profile-dashboard/patientDashboardStore";
import { formatDate } from "@/utils/datetime";
import cardItemCount from "@/features/patients/profile-dashboard/mixins/cardItemCount.js";

export default {
  name: "DietaryRecallCard",
  mixins: [cardItemCount],

  props: {
    infoTitle: { type: String, default: "Recordatório Alimentar" },
    patientId: { type: [String, Number], required: true },
    icon: { type: String, default: null },
  },

  data() {
    return { records: [] };
  },

  computed: {
    /** SALVIA-938: itens do card, para o contador da caixa lateral. */
    itemCount() {
      return (this.records || []).length;
    },
    latest() {
      return this.records.length ? this.records[0] : null;
    },
  },

  watch: {
    patientId: "fetchData",
  },

  created() {
    this.fetchData().finally(() => this.$emit("card-loaded"));
  },

  methods: {
    formatDate,
    async fetchData() {
      if (!this.patientId) return;
      try {
        this.records = await dashboardStore.section(this.patientId, "dietary_recalls", () => getDietaryRecallByPatient(this.patientId));
      } catch (error) {
        console.error("Erro ao buscar recordatório alimentar:", error);
        this.records = [];
      }
    },
  },
};
</script>

<style scoped>
/* ═══ Tema: Verde (Recordatório Alimentar) ═══ */
.card-fixed-height {
  display: flex;
  flex-direction: column;
  height: 320px;
  border-radius: 14px !important;
  border: 1px solid #bbf7d0 !important;
  box-shadow: 0 2px 10px rgba(21, 128, 61, 0.1) !important;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.card-fixed-height:hover {
  border-color: #86efac !important;
  box-shadow: 0 6px 20px rgba(21, 128, 61, 0.18) !important;
}

.card-header {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  min-width: 0;
  background: var(--ds-soft-green);
  border-bottom: 1px solid #bbf7d0;
}

.card-title-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--ds-cat-green);
  letter-spacing: 0.3px;
}

.card-content {
  flex: 1;
  overflow-y: auto;
}

.recall-content {
  font-size: 13px;
  color: var(--ds-text-600);
  line-height: 1.6;
  white-space: pre-wrap;
  margin-bottom: 8px;
}

.recall-date {
  font-size: 11px;
  color: var(--ds-cat-green);
  font-weight: 600;
  margin: 0;
}
</style>
